import {
  getPeopleFieldOptions,
  PEOPLE_DEFAULT_SORT,
  PEOPLE_NAME_FIELDS,
  PEOPLE_STYLE_CONFIG,
} from './people';
import { DEFAULT_STYLE_CONFIG, WIDGET_ENTITY_TYPE } from './shared';

export * from './people';
export * from './regForm';
export * from './shared';

// Lives here, not in shared.js: the per-type files import shared,
// so composing them there would create a cycle.
// The API requires appliedEntityType and a non-empty viewFields.
export const DEFAULT_WIDGET_CONFIG = {
  [WIDGET_ENTITY_TYPE.PEOPLE]: {
    queryConfig: { appliedEntityType: 'all', sort: PEOPLE_DEFAULT_SORT },
    fieldConfig: {
      viewFields: [...PEOPLE_NAME_FIELDS, ...getPeopleFieldOptions().map(({ value }) => value)],
    },
    styleConfig: PEOPLE_STYLE_CONFIG,
  },
  [WIDGET_ENTITY_TYPE.SESSIONS]: {
    queryConfig: { appliedEntityType: 'all', sort: 'start_datetime' },
    fieldConfig: { viewFields: ['name'] },
    styleConfig: DEFAULT_STYLE_CONFIG,
  },
  [WIDGET_ENTITY_TYPE.COMPANIES]: {
    queryConfig: { appliedEntityType: 'all', sort: 'name' },
    fieldConfig: { viewFields: ['name'] },
    styleConfig: DEFAULT_STYLE_CONFIG,
  },
};
